import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const Container = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Header = styled.div`
    width: 100%;
    // Usado também em Home e em agronomos/editV2 - por isso o max-width é
    // configurável via prop (maxWidth), em vez de alterar o padrão aqui, que
    // afetaria as outras duas telas. Só a tela de Fazenda passa um valor diferente.
    max-width: ${(props) => props.maxWidth || "64.875rem"};
    padding: 1.5rem 1.625rem;

    display: flex;
    align-items: center;
    border-radius: 1.5rem;
    justify-content: space-between;    

    background-color: ${theme.colors.green.Verde_AgroReceita};

    @media (max-width: 980px) {
        gap: 1.5rem;
        flex-direction: column;
    }

    @media (max-width: 612px) {
        >h5{
            text-align: center;

            font-size: 1rem;
        }
    }
`;

export const ButtonHeader = styled.button`
    all:unset;
    display: flex;
    width: 11.625rem;
    padding: 1rem 2.5rem;
    
    align-items: center;
    border-radius: 62rem;
    letter-spacing: 0.1rem;
    background-color: ${theme.colors.gray.Cinza_2};

    img{
        width: 1.3rem;
        
        margin-right: 1rem;

        @media (max-width: 612px) {
            width: 1rem;
            
            margin-right: 0.4rem;
        }
    }

    >p{
        cursor: pointer;
        
        text-align: center;
    }

    @media (max-width: 612px) {
        width: 9.125rem;
        font-size: 0.5rem;
    }

    :hover{
        cursor: pointer;
        transition: 0.5s;
        background-color: ${theme.colors.green.Bandeira};
    }

    :not(:hover){
        transition: 0.3s;
    }
`;